<p>
  Редактирането на обява ви позволява да направите корекции или допълнения след публикуване – било то за коригиране на
  грешки, добавяне на информация или актуализиране на снимки. Това е важна функционалност, която ви помага да поддържате
  обявата си актуална и представителна.
</p>
<h6 class="mt-3">Как да достъпите редакцията?</h6>
<p class="mb-1">
  Имате два начина за достъп до формата за редактиране:
</p>
<ul>
  <li>
    От <strong>страницата на самата обява</strong>, чрез бутона <strong>„Редактиране на обявата“</strong>.
  </li>
  <li>
    От <strong>„Профил“ → „Моите обяви“</strong>, като натиснете бутона с <strong>три точки (⋮)</strong> в десния ъгъл на
    съответната обява и изберете <strong>„Редактиране на обявата“</strong>.
  </li>
</ul>
<h6 class="mt-3">Какво се случва при редактиране?</h6>
<p>
  Ще се отвори формата за създаване на нова обява с вече попълнени полета със съществуващата информация. Може да
  направите нужните промени и да ги запазите.
</p>
<h6 class="mt-3">Ограничения при редакция</h6>
<p class="mb-1">
  Съществуват някои ограничения в зависимост от състоянието и типа на обявата:
</p>
<ul>
  <li><strong>Видът на обявата</strong> (фиксирана цена или аукцион) <strong>не може да бъде променян</strong> след
    публикуване.
  </li>
  <li><strong>Началната и крайната дата/час</strong> също не подлежат на редакция след публикуване.</li>
  <li>При <strong>обяви с наддаване</strong> не могат да се редактират следните полета:
    <ul>
      <li>Начална цена</li>
      <li>Минимална стъпка</li>
      <li>Купи сега цена</li>
      <li>Запазена цена</li>
      <li>Настройка за удължаване на аукциона</li>
    </ul>
  </li>
  <li>
    <strong>Редактирането не е възможно</strong> за обяви, които вече са <strong>завършили със сделка</strong>.
  </li>
</ul>
<h6 class="mt-3">Как да запазите промените?</h6>
<p>
  След приключване с редакциите, натиснете бутона <strong>„Запази“</strong> в четвъртата стъпка от формата. Обявата ви
  ще бъде актуализирана незабавно и видима с новите параметри.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Преглеждайте внимателно заглавието, снимките и описанието. Дори малка корекция в начина на
  представяне може да увеличи интереса и доверието на потенциалните купувачи.
</div>
